(() => {
  document.addEventListener('alpine:init', () => {
    
    GetRebateVariant = async (rebate_item) => {
      let handle = rebate_item.item2Handle;
      let product_res = await fetch(`/products/${handle}.js`);
      if (!product_res.ok) {
        console.error('PRODUCT NOT FOUND!', `/products/${handle}.js`);
        return;
      };
      let product = await product_res.json();
      let rebate_section_id = 'product-rebates';
      let variant = product.variants.find(v => v.id == rebate_item.item2Id);
      let product_rebates_res = await(fetch(`/products/${product.handle}?sections=${rebate_section_id}`)).then(res => res.json());
      let $product_rebates_res = UTILS.ConvertStringToHTML(product_rebates_res[rebate_section_id]).querySelector('[data-rebates]');
      let rebates = $product_rebates_res.dataset.rebates ? JSON.parse($product_rebates_res.dataset.rebates) : [];
      product.rebates = rebates;
      product.variants = null;
      variant.product = {...product};
      // console.log(variant.sku, variant, rebates, rebate_item);
      document.dispatchEvent(new CustomEvent('rebate:variant:loaded', { detail: { variant: variant }}));
      return variant;
    }

    GetVariantSavings = (kit, variant, flags) => {
      if (!variant) return 0;
      let compare_at_price = variant.compare_at_price || variant.price;
      let price = variant.price;
      let savings = compare_at_price - price;

      if (flags.is_parent_item) {
        if (!flags.is_solo_item) {
          let rebate_items = kit.items_to_add.filter(v => v.flags.is_rebate_item);
          let not_stackable_rebate_items = rebate_items.filter(v => !v.flags.is_stackable && !v.flags.is_solo_item);
          if (not_stackable_rebate_items.length > 0) {
            savings += Math.max(...not_stackable_rebate_items.map(v => v.rebate_item.amountInCents));
          }
          else {
            let stackable_rebate_items = rebate_items.filter(v => v.flags.is_stackable);
            savings += stackable_rebate_items.reduce((sum, v) => sum + v.rebate_item.amountInCents, 0);
          }  
        }
        else {
          let rebate_items = kit.items_to_add.filter(v => v.flags.is_rebate_item);
          let stackable_rebate_items = rebate_items.filter(v => v.flags.is_stackable);
          savings += stackable_rebate_items.reduce((sum, v) => sum + v.rebate_item.amountInCents, 0);
        }
      }
      else {
        if (flags.is_solo_item) {
          savings = compare_at_price - price;
        }
        else {
          savings = 0;
        }
      }
      return savings;
    }

    GetVariantChildSavings = (kit, variant, flags) => {
      if (!variant || flags.is_parent_item ) return 0;
      let childSavings = 0;
      console.log(variant.product.title)
      if (flags.is_parent_item) {
        console.log('is parent item');
      } else {
        console.log('is not parent item');
          if (flags.is_rebate_item) {
            childSavings = variant.rebate_item.amountInCents;
          }
          if (!kit.parent_variant.flags.is_stackable) {
            childSavings = 0;
          }
      }
      return childSavings;
    }

    GetVariantFlags = (variant) => {
      let flags = {};

      if (!variant) return;
      if (!variant.product) return;
      let is_solo_item = variant.product.tags.includes('_solorebate');
      flags.is_solo_item = is_solo_item;

      let is_stackable = false;
      if (variant.rebate_item) {
        is_stackable = variant.rebate_item.stackable;
      }
      else {
        is_stackable = !variant.product.tags.includes('_nonstacking');
      }
      
      flags.is_stackable = is_stackable;
      return flags;
    }

    Alpine.data('KitBuilder', () => ({
      items_to_add: [],
      parent_variant: {},
      init() {
        this.InitSelf();
        this.InitWatchers();
        this.CheckTabs();
      },
      InitSelf() {
        let am = this;
        let parent_variant = JSON.parse(am.$el.dataset.parent_variant);
        am.SetParentVariant(parent_variant);
      },
      SetParentVariant(variant) {
        let am = this;
        
        let parent_variant = variant;
        let parent_product = JSON.parse(am.$el.dataset.parent_product);
        let rebates = am.$el.dataset.rebates ? JSON.parse(am.$el.dataset.rebates) : [];
        parent_product.rebates = rebates;
        parent_variant.product = parent_product;

        if (!parent_variant.featured_image) {
          parent_variant.featured_image = parent_variant.product.media[0].src;
        }
        parent_variant.flags = {
          is_parent_item: true,
          is_rebate_item: false,
          is_solo_item: parent_variant.product.tags.includes('_solorebate'),
          is_stackable: !parent_variant.product.tags.includes('_nonstacking')
        }
        parent_variant.is_added_item = true;
        am.parent_variant = {...parent_variant};
        // remove any previous parent item from items_to_add
        let items_to_add = am.items_to_add.filter(v => !v.flags.is_parent_item);
        am.items_to_add = [...items_to_add, ...[parent_variant]];
      },
      InitWatchers() {
        let am = this;
        subscribe(PUB_SUB_EVENTS.variantChange, (e) => {
          am.SetParentVariant(e.data.variant);
          let $btn_kit_cta = document.querySelector('.button--show-kit-cta');
          if ($btn_kit_cta) {
            $btn_kit_cta.classList.toggle('hidden', !e.data.variant.available);
          }
        });

        // after variant rebates loaded, check tabs
        document.addEventListener('rebate:variant:loaded', am.CheckTabs.bind(am));
      },
      GetImageSrcset(src) {
        return `${ src }&width=550 550w, ${ src }&width=1100 1100w, ${ src }&width=1445 1445w, ${ src }&width=2048 2048w`
      },
      GetImageUrl(src, width) {
        if (typeof src === 'object') {
          src = src.src;
        }
        return `${ src }&width=${ width }`
      },
      GetSoloItemsSavings() {
        let am = this;
        let solo_items = am.items_to_add.filter(v => v.flags.is_solo_item && !v.flags.is_parent_item); 
        let savings = solo_items.reduce((sum, v) => {
          let compare_at_price = v.compare_at_price || v.price;
          let savings = compare_at_price - v.price; 
          return sum + savings;
        }, 0);
        return savings;
      },
      GetParentSavings() {
        let am = this;
        return GetVariantSavings(am, am.parent_variant, am.parent_variant.flags);
      },
      GetTotalSavings() {
        let am = this;
        return am.GetSoloItemsSavings() + am.GetParentSavings();
      },
      GetKitPrice() {
        let am = this;
        let kit_total_price = am.items_to_add.reduce((sum, v) => sum + (v.compare_at_price || v.price), 0);
        return kit_total_price;
      },
      e_ToggleItemInKit(variant) {
        let am = this, items_to_add = [];
        variant.flags = am.flags;
        let is_added_to_kit = am.items_to_add.filter(v => v.id == variant.id).length !== 0;

        if (!is_added_to_kit) {
          items_to_add = [...am.items_to_add, ...[variant]];
        }
        else {
          items_to_add = am.items_to_add.filter(v => v.id !== variant.id);
        }

        am.items_to_add = [...items_to_add];
      },
      IsVariantInKit(variant) {
        let am = this;
        return am.items_to_add.filter(v => v.id == variant.id).length !== 0;
      },
      async e_AddKitItemsToCart() {
        let am = this;
        if (!am.parent_variant.available) return;
        let items_to_add = am.items_to_add.map(v => {
          return {
            id: v.id,
            quantity: 1
          }
        });
        await UTILS.AddItemsToCart(items_to_add);
        document.dispatchEvent(new CustomEvent('theme:cart:refresh'));
      },
      CheckTabs() {
        let am = this;
        am.$el.querySelectorAll('.tab-panels .tab-panel-rebate').forEach(($tab_panel) => {
          let tab_id = $tab_panel.dataset.tab_id;
          let $radio = am.$el.querySelector(`input[id="${tab_id}"]`);
          let $tab = am.$el.querySelector(`label[for="${tab_id}"]`);
          let $rebate_items = $tab_panel.querySelectorAll('.rebate--item');
          // console.log($tab_panel, $rebate_items);
          $radio.classList.toggle('hidden', $rebate_items.length == 0);
          $tab.classList.toggle('hidden', $rebate_items.length == 0);
          $tab_panel.classList.toggle('hidden', $rebate_items.length == 0);
        });
        let $first_tab = am.$el.querySelector('[name="kit-tabset"]:not(.hidden)');
        if ($first_tab) {
          $first_tab.checked = true;
          $first_tab.dispatchEvent(new Event('change'));  
        }
        // console.log($first_tab);
      }
    }));

    Alpine.data('RebateKitItem', (is_rebate_item) => ({
      is_added_item: false,
      flags: {
        is_parent_item: false,
        is_rebate_item: is_rebate_item || false,
        added_to_kit: false,
        is_solo_item: false,
        is_stackable: false
      },
      variant: null,
      savings: 0,
      childSavings: 0, 
      init() {
        this.InitWatchers();
        this.InitSelf();
      },
      async InitSelf() {
        let am = this;

        if (am.flags.is_rebate_item) {
          am.SetVariantRebateItem();
        }
        else {
          am.SetVariantRegularItem();
        }
        am.UpdateFlags();
        am.UpdateSavings();
        am.UpdateChildSavings();
      },
      async SetVariantRebateItem() {
        let am = this;
        let rebate_item = JSON.parse(am.$el.dataset.rebate_item);
        if (!rebate_item.item2Id) return;

        let variant = await GetRebateVariant(rebate_item);
        if (!variant) {
          am.$el.remove();
          return;
        }

        // if variant has no image, use product first image
        if (!variant.media) {
          variant.media = variant.product.media[0]
        }

        variant.rebate_item = rebate_item;
        am.variant = {
          ...variant
        };
        // console.log(am.$el, am.variant);
      },
      SetVariantRegularItem() {
        let am = this;

        let variant = JSON.parse(am.$el.dataset.variant);
        let product = JSON.parse(am.$el.dataset.product);
        let rebates = JSON.parse(am.$el.dataset.rebates);
        product.rebates = rebates;
        variant.product = product;

        // if variant has no image, use product first image
        if (!variant.featured_image) {
          variant.featured_image = product.images[0];
        }

        am.variant = {
          ...am.variant,
          ...variant
        };
        console.log(am.$el, am.variant);
      },
      InitWatchers() {
        let am = this;
        am.$watch('variant', am.UpdateFlags.bind(am));
        am.$watch('variant', am.UpdateSavings.bind(am));
        am.$watch('variant', am.UpdateChildSavings.bind(am));
        am.$watch('items_to_add', am.UpdateSavings.bind(am));
      },
      UpdateFlags() {
        let am = this;
        if (!am.variant) return;
        am.flags = {
          ...am.flags,
          ...GetVariantFlags(am.variant)
        };
      },
      UpdateChildSavings(){
        let am = this;
        if (!am.variant) return;
        am.childSavings = GetVariantChildSavings(am, am.variant, am.flags);
      },
      UpdateSavings() {
        let am = this;
        if (!am.variant) return;
        am.savings = GetVariantSavings(am, am.variant, am.flags);
      }
    }));

    Alpine.data('KitItem_added', (variant) => ({
      variant: variant,
      savings: 0,
      is_added_item: true,
      flags: {
        is_parent_item: false,
        is_solo_item: false,
        is_stackable: false,
        is_rebate_item: false,
        is_added_to_kit: true
      },
      init() {
        this.UpdateFlags();
        this.UpdateSavings();
        //this.UpdateChildSavings();
      },
      UpdateFlags() {
        let am = this;
        if (!am.variant) return;
        let flags = {
          is_parent_item: am.parent_variant.product.id == am.variant.product.id,
          is_rebate_item: am.variant.rebate_item ? true : false
        };

        am.flags = {
          ...am.flags,
          ...flags,
          ...GetVariantFlags(am.variant)
        };
      },
      UpdateSavings() {
        let am = this;
        am.savings = GetVariantSavings(am, am.variant, am.flags);
      }
    }));
  });
})()
